import axios from 'axios';

/**
 * API Configuration
 * 
 * API Base URL: https://dhanwalle.fintechsmartsolutions.com/Api/TaskApi
 * (Updated for subdomain testing)
 * 
 * Production URL: https://dhanwalle.in/Api/TaskApi
 */

const API_BASE_URL = 'https://dhanwalle.fintechsmartsolutions.com/Api/TaskApi';

/**
 * Save enquiry to the API
 * @param {string} name - Name of the person
 * @param {string} mobile - Mobile number (10 digits)
 * @returns {Promise} API response
 */
export const saveEnquiry = async (name, mobile) => {
  try {
    const url = 'https://dhanwalle.fintechsmartsolutions.com/index.php/Api/RepayLoanApi/SaveEnquiry';
    console.log('API URL being called:', url);
    
    const response = await axios.post(
      url,
      {
        Name: name.trim(),  
        Mobile: mobile.trim().replace(/\s+/g, '')
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: false
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error saving enquiry:', error);
    if (error.response) {
      // Server responded with error
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
    } else if (error.request) {
      // Request made but no response
      console.error('No response received:', error.request);
    } else {
      // Error in setting up request
      console.error('Error:', error.message);
    }
    throw error;
  }
};

/**
 * Get list of enquiries from the API
 * @returns {Promise} API response with enquiry list
 */
export const getEnquiryList = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/GetEnquiryList`,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching enquiry list:', error);
    throw error;
  }
};

/**
 * Customer enquiry API from RepayLoanApi
 * @param {Object} params - Optional parameters for the enquiry
 * @returns {Promise} API response with customer enquiry data
 */
export const customerEnquiry = async (params = {}) => {
  try {
    const url = 'https://dhanwalle.fintechsmartsolutions.com/index.php/Api/RepayLoanApi/customer_enquiry';
    console.log('Customer Enquiry API URL:', url);
    
    const response = await axios.get(
      url,
      {
        params: params,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: false
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching customer enquiry:', error);
    if (error.response) {
      // Server responded with error
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
    } else if (error.request) {
      // Request made but no response
      console.error('No response received:', error.request);
    } else {
      // Error in setting up request
      console.error('Error:', error.message);
    }
    throw error;
  }
};

